import {Component, Input, OnInit} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalDismissReasons, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {ShoppingModel} from '../../models/shopping.model';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {AngularFireDatabase} from 'angularfire2/database';
import {Observable} from 'rxjs/Observable';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgxMaskModule} from 'ngx-mask';
import {NfModel} from '../../models/nf.model';
import {AuthenticationService} from '@app/core/authentication/authentication.service';
import {UtilityService} from '../core/utils.service';
import {CouponResumeModel} from '../../models/coupon-resume.model';
import {PlaceServiceBase} from '@app/core/places.service';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';
import {WynkNavigate, WynkResponseModel} from '../../models/action.model';
import {VouchersModel, VouchersStatus} from '../../models/vouchers.model';
import {AnswerModel, QuizModel} from '../../models/quiz.model';

@Component({
  selector: 'app-shopping-promotions',
  templateUrl: './shopping-promotions.component.html',
  styleUrls: ['./shopping-promotions.component.scss']
})
export class ShoppingPromotionsComponent {
  promotions: ShoppingPromotionModel[] = [];
  resume: any;
  shopping: ShoppingModel;
  shoppingId: any;
  coupons: any;
  couponsFiltered: any;
  closeResult: string;
  selectedItem: ShoppingPromotionModel;
  establishments: any;
  details: any;
  modalReference: NgbModalRef;
  quizModalreference: NgbModalRef;
  nfModalReference: NgbModalRef;
  successModalReference: NgbModalRef;
  nfInputVisible = false;
  userCuponsVisible = false;
  foreco = false;
  code = '';
  codeForm: FormGroup;
  items: Observable<any[]>;
  modalContent: any;
  nfModel: NfModel;
  message = '';
  nfResult: any;
  qtdScratchs: number;
  qtdCoupons: number;
  qtdWynks: number;
  isLoadingList = true;
  establishmentSearch = '';
  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;
  quiz: QuizModel;
  answer: AnswerModel;
  private codeAux = '';
  constructor(private formBuilder: FormBuilder,
              private shoppingService: ShoppingService,
              private chainService: ChainService,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private router: Router,
              private authenticationService: AuthenticationService,
              private db: AngularFireDatabase,
              private util: UtilityService,
              private domainService: DomainService) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;
    this.route.params.subscribe( params => {
      this.loadShoppingPromotions(params.shoppingId);
      this.shoppingId = params.shoppingId;
    } );

    this.items = db.list('ti/wynk/promotion').valueChanges();
    this.items.subscribe(changedItems => {
      // TODO: Alterar os status de acordo com as mudanças do firebase
      console.log(changedItems);
    });

    this.codeForm = this.formBuilder.group({
      code: ['', Validators.required],
    });
  }

  clearEstablishmentList() {
    this.establishmentSearch = '';
  }

  radioChange(answer: any) {
    this.answer = answer;
  }

  registerQuiz(contentNfc: any, contentQuiz: any) {
    this.placeService.registerQuiz(this.selectedItem.id_hash, this.answer.cod)
      .pipe(finalize(() => {
      }))
      .subscribe((result) => {
        this.code = this.codeAux;
        this.codeAux = '';
        this.registerNfc(contentNfc, contentQuiz);
      }, error => {
        console.log(error);
      });
  }

  openQuiz(content: any, response: any) {
    const wynkResponseModel: WynkResponseModel = response;
    if (wynkResponseModel.actions[0].type === 0) {
      const wynkNavigate: WynkNavigate = wynkResponseModel.actions[0].data;
      this.placeService.getCampaignQuiz(wynkNavigate.id)
        .pipe(finalize(() => {
        }))
        .subscribe( (quiz) => {
          if (quiz.title) {
            this.quiz = quiz;
            if (this.quiz.answers[0]) {
              this.answer = this.quiz.answers[0];
            }
            this.quizModalreference = this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
            this.modalReference.close();
          } else {
            console.log(quiz.status);
          }

        }, error => {
          console.log(error);
        });
    }
  }

  registerNfc(content: any, contentQuiz: any) {
    this.modalContent = content;
    this.placeService.registerNfcPromotion(this.code)
      .pipe(finalize(() => {
      }))
      .subscribe(response => {
        if (response.actions && response.actions.length > 0) {
          this.codeAux = this.code;
          this.openQuiz(contentQuiz, response);
        } else {
          const nfModel: NfModel = response.data;
          if (nfModel && nfModel.id) {
            this.message = '';
            this.nfModel = nfModel;
            this.openNF(this.modalContent);
          } else {
            this.message = response._body;
          }
        }
        this.code = '';
      }, error => {
        this.code = '';
        this.message = 'Ocorreu um erro ao recuperar sua nota.';
        console.log(`Nfc error: ${error}`);
      });
  }

  openNF(content: any) {
    this.nfModalReference = this.modalService.open(content, { windowClass: 'modal-centered modal-md modal-details' });
    if (this.quizModalreference) {
      this.quizModalreference.close();
    }
    this.modalReference.close();
  }

  loadShoppingPromotions(shoppingId: string) {
    if (this.authenticationService.credentials) {
        this.placeService.getPromotionsPrivate(shoppingId)
            .pipe(finalize(() => {
            }))
            .subscribe(promotions => {
                this.isLoadingList = false;
                this.promotions = promotions;
            }, error => {
                console.log(`shopping error: ${error}`);
            });
    } else {
        this.placeService.getPromotions(shoppingId)
            .pipe(finalize(() => {
            }))
            .subscribe(promotions => {
                this.isLoadingList = false;
                this.promotions = promotions;
            }, error => {
                console.log(`shopping error: ${error}`);
            });
    }

    this.placeService.getShopping(shoppingId)
      .pipe(finalize(() => {
      }))
      .subscribe(shopping => {
        this.shopping = shopping;
        this.util.setBarBackground(this.shopping.backgroundColor);
        this.util.setBarTextColor(this.shopping.textColor);
      }, error => {
        console.log(`shopping error: ${error}`);
      });
  }

  navbarLeftText() {
    return `Exibindo ${this.promotions.length} Promoções`;
  }

  openTroca(content: any, item: ShoppingPromotionModel) {
    /* if (!this.authenticationService.credentials) {
      this.util.openLoginModal(this.modalService, null);
      return;
    } */

    this.placeService.getCampaignPublic(item.id_hash)
      .pipe(finalize(() => {
      }))
      .subscribe(campaign => {
        this.establishments = campaign.establishments;
      }, error => {
        console.log(`get establishments details error: ${error}`);
      });


    if (this.authenticationService.credentials) {
      this.placeService.getPromotionUserDetails(item.id_hash)
        .pipe(finalize(() => {
        }))
        .subscribe(campaignDetails => {
          this.details = campaignDetails;
        }, error => {
          console.log(`get establishments details error: ${error}`);
        });
    }

    this.selectedItem = item;
    this.modalReference = this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
    this.modalReference.result.then(() => {
      this.code = '';
      this.message = '';
      this.nfInputVisible = false;
      this.userCuponsVisible = false;
      this.foreco = false;
    }, () => {
      this.code = '';
      this.message = '';
      this.nfInputVisible = false;
      this.userCuponsVisible = false;
      this.foreco = false;
    });
  }

  showNfInput() {
    this.userCuponsVisible = false;
    this.nfInputVisible = true;
  }

  showUserNotes() {
      if (this.authenticationService.credentials) {
        this.userCuponsVisible = true;
        this.placeService.getUserCoupons(this.promotions[0].id_hash)
          .pipe(finalize(() => {
          }))
          .subscribe(coupons => {
            this.isLoadingList = false;
            this.resume = coupons;
            if (this.resume.coupons === 0) {
              this.showNfInput();
            }
          }, error => {
            console.log(`shopping error: ${error}`);
          });
        return;
      }
      this.util.openLoginModal(this.modalService, null);
  }

  showUserCupons() {
    if (this.authenticationService.credentials) {
      this.placeService.getCoupons(this.shoppingId)
        .pipe(finalize(() => {
        }))
        .subscribe(coupons => {
          coupons.forEach(coupom => {
            coupom.opened = false;
          });

          const data = coupons.filter(item => item.campaign === this.promotions[0].id);
          console.log(coupons[0].coupons[0].code);
          this.coupons = data[0];

          this.userCuponsVisible = false;
          this.foreco = true;
          console.log(this.coupons);

        }, error => {
          console.log(`shopping error: ${error}`);
        });
      return;
    }
    this.util.openLoginModal(this.modalService, null);
  }

  openPromotion(promotion: ShoppingPromotionModel) {
    this.router.navigate(['/shopping/[shoppingId]/promotion/[promotionId]'
      .replace('[shoppingId]', this.shopping.id_hash)
      .replace('[promotionId]', promotion.id_hash)
    ]);
    this.modalReference.dismiss();
  }

  openLottery(promotion: ShoppingPromotionModel) {
    this.router.navigate(['/shopping/[shoppingId]/promotion/[promotionId]/lottery'
      .replace('[shoppingId]', this.shopping.id_hash)
      .replace('[promotionId]', promotion.id_hash)
    ]);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  calculateDaysBetweenNowAndADate(date: Date) {
    const end = moment(date);
    const current = moment(new Date());
    return end.diff(current, 'days');
  }

  confirmNfce(contentSuccess: any) {
    this.placeService.confirmNfce(this.nfModel.id)
      .pipe(finalize(() => {
      }))
      .subscribe(confirmResult => {
        if (confirmResult) {
          this.nfModalReference.dismiss();
          confirmResult.forEach((nfResult: any) => {
            this.nfResult = nfResult;
            if (this.nfResult && !this.nfResult.status) {
              this.qtdCoupons = this.nfResult.resumeReedemNF.coupons.length;
              this.qtdWynks = Math.floor(this.nfResult.resumeReedemNF.wynks);
              this.qtdScratchs = this.nfResult.resumeReedemNF.scratchs.length;
              this.successModalReference = this.modalService.open(contentSuccess,
                { windowClass: 'modal-centered modal-md' });
            }
          });
        } else {
          alert('Ocorreu um erro ao aprovar sua nota.');
        }
      }, error => {
        alert('Ocorreu um erro ao aprovar sua nota.');
        console.log(`Nfc error: ${error}`);
      });
  }

  openScratch() {
    if (this.authenticationService.credentials) {
      const link = `/shopping/${this.shoppingId}/scratches`;
      this.modalReference.close();
      this.router.navigate([link]);
      return;
    }
    this.util.openLoginModal(this.modalService, null);
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotions/shopping-promotions.component.ts